/**
 * What a record panel's `renders` entry claims, and how it is matched.
 *
 * The TypeScript copy of `workbench/server/panels/claims.py`. Three forms:
 *
 * - `l0.effect.released` -- an exact event kind (the timeline only);
 * - `producer_video.` -- every tool under that prefix;
 * - `tool:subagent.delegate` -- that one tool.
 *
 * A tool claim is never matched against an event's kind: a prefix that
 * claimed every kind starting with the plugin's name would quietly swallow
 * events the plugin never meant to own.
 */

export const TOOL_CLAIM = "tool:";

/** Is this entry a claim on tools rather than on an event kind? */
export function claimsTools(claim: string): boolean {
  return claim.startsWith(TOOL_CLAIM) || claim.endsWith(".");
}

/** Does this entry claim calls of `tool`? */
export function toolClaimMatches(claim: string, tool: string | null | undefined): boolean {
  if (!tool) return false;
  if (claim.startsWith(TOOL_CLAIM)) return tool === claim.slice(TOOL_CLAIM.length);
  if (claim.endsWith(".")) return tool.startsWith(claim);
  return false;
}

/** Does this entry claim this ledger event? */
export function recordClaimMatches(
  claim: string,
  kind: string,
  tool: string | null | undefined,
): boolean {
  if (claimsTools(claim)) return toolClaimMatches(claim, tool);
  return kind === claim;
}
